import React, { useState, useEffect } from "react";
import { Card, Form, Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";


function ResendActivation() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (submitted) {
      const timer = setTimeout(() => {
        navigate("/login");
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [submitted, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");

    try {
      const res = await fetch("/api/auth/resend-activation", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (res.ok) {
        setMessage("Activation link has been sent. Please check your email. You will be redirected to the login form in 10 seconds.");
        setSubmitted(true);
      } else {
        if (data.detail === "Account is already activated.") {
          setMessage("Account is already activated. You can log in. You will be redirected to the login form in 10 seconds.");
          setSubmitted(true);
        } else {
          setError(data.detail || "Something went wrong");
        }
      }
    } catch (err) {
      setError("Network error");
    } finally {
      setLoading(false);
    }
  };

  return (<><Helmet> <title>Resend Activation Code- IndexBooster</title></Helmet>

    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <Card style={{ width: "400px", padding: "20px" }}>
        <Card.Body>
          <h1 className="text-center">Resend Activation</h1>
          {message && <Alert variant="success">{message}</Alert>}
          {error && <Alert variant="danger">{error}</Alert>}

          {!submitted && (
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>
              <Button variant="primary" type="submit" className="w-100 mt-3" disabled={loading}>
                {loading ? "Sending..." : "Send activation link"}
              </Button>
              <div className="text-center mt-3">
                <a href="/login">Back to login</a>
              </div>
            </Form>
          )}
        </Card.Body>
      </Card>
    </div>
  </>);
}

export default ResendActivation;
